<template>
</template>

<script>

export default {
  name: "ForgetPassword",
};
</script>

<style scoped>

</style>